type ShouldShowPartnersListInitialSkeletonArgs = {
  hasInitiallyLoaded: boolean
  isLoading: boolean
  isSuccess: boolean
}

/**
 * Skeleton inicial só antes da primeira carga bem-sucedida.
 * Refetch por filtro não deve desmontar a barra de busca (perda de foco).
 */
export function shouldShowPartnersListInitialSkeleton({
  hasInitiallyLoaded,
  isLoading,
  isSuccess
}: ShouldShowPartnersListInitialSkeletonArgs) {
  return !hasInitiallyLoaded && (isLoading || !isSuccess)
}
